export enum UserDetailMode {
  VIEW = "VIEW",
  CREATE = "CREATE",
  EDIT = "EDIT"
}

export enum FormType {
  OTHER = 1,
  CUSTOMER = 3,
  SALES = 2
}

export enum CustomerType {
  INTERNAL = "Internal",
  EXTERNAL = "External"
}

export enum ParentGroupCode {
  ADMIN = "ADMIN",
  CS_DOMESTIC = "CS DOMESTIC",
  CS_EXPORT = "CS EXPORT",
  CUSTOMER = "CUSTOMER",
  CUSTOMER_CIP = "CUSTOMER(CIP)",
  MANAGER = "MANAGER",
  PRODUCTION_PLANNING = "PRODUCTION PLANNING",
  SALES = "SALES",
  SECTION = "SECTION",
  SERVICE_SOLUTION = "SS(SERVICE SOLUTION)"
}

export const ParentGroupFormType = {
  [ParentGroupCode.ADMIN]: FormType.OTHER,
  [ParentGroupCode.CS_DOMESTIC]: FormType.OTHER,
  [ParentGroupCode.CS_EXPORT]: FormType.OTHER,
  [ParentGroupCode.CUSTOMER]: FormType.CUSTOMER,
  [ParentGroupCode.CUSTOMER_CIP]: FormType.OTHER,
  [ParentGroupCode.MANAGER]: FormType.OTHER,
  [ParentGroupCode.PRODUCTION_PLANNING]: FormType.OTHER,
  [ParentGroupCode.SALES]: FormType.SALES,
  [ParentGroupCode.SECTION]: FormType.OTHER,
  [ParentGroupCode.SERVICE_SOLUTION]: FormType.OTHER
};
